import { PurposeType } from '@src/types/enum.js';
import {
  App, ConsentUpdate, Purpose,
} from '@src/types/model.js';

const transformApps4Save = (apps: App[]): ConsentUpdate[] => apps
  .filter((app) => !app.granted)
  .map((app) => ({
    id: app.consentId,
    status: 'revoked',
  }));

//
// Transform for POST ConsentUpdateList
// but only not granted consents should be saved
//
export const transformConsents4Save = (actualConsents: Purpose[]): ConsentUpdate[] => {
  let revokesPayload: ConsentUpdate[] = [];

  const identifierBoundPurposes = actualConsents.filter((purpose) => purpose.purposeType === PurposeType.identifier_bound);
  const userBoundPurposes = actualConsents.filter((purpose) => purpose.purposeType === PurposeType.user_bound);

  identifierBoundPurposes.forEach((purpose) => {
    purpose.subscriptions!.forEach((subscription) => {
      revokesPayload = revokesPayload.concat(transformApps4Save(subscription.apps));
    });
  });

  userBoundPurposes.forEach((purpose) => {
    revokesPayload = revokesPayload.concat(transformApps4Save(purpose.apps!));
  });

  return revokesPayload;
};
